/**
 * Template placeholders that resolve at the moment a ticket is created.
 *
 * `ACTOR` means "whoever is creating this ticket". A form template stores it
 * INSTEAD of a real id, because storing the author's own id would put their
 * name on every ticket anybody ever made from that template — Kai's case:
 * *"if I'm an agent, I create a ticket using this form, I want it assigned to
 * me in the group selected"*, and the same for the requester on a monitoring
 * incident or a backlog task, where the agent raising it IS the requester.
 *
 * ── Why this is in `shared` ────────────────────────────────────────────
 *
 * It failed on its first save: the editor wrote `@me` and the server's zod
 * schema said `assigneeId: z.string().uuid()`, so the template could be built
 * and never stored — "prefill.assigneeId: Invalid uuid".
 *
 * That is the exact failure this package exists to prevent. One side knowing a
 * value the other rejects is the drift `buildFieldSchema` was put here to
 * stop, and a sentinel is the smallest possible version of it. The validator
 * below is the single definition of "is this allowed", imported by the schema
 * that enforces it and the editor that produces it.
 */
export const TEMPLATE_ACTOR = '@me' as const;

/** A template's assignee: a real UUID, or "whoever creates the ticket". */
export function isTemplateActorOrUuid(v: string): boolean {
  return v === TEMPLATE_ACTOR || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
}
